@import "../arrow";

:host {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: $zindex-topmost;
  box-shadow: 0 0 4px 0 rgba($color-black, 0.2);
  border-radius: $border-radius-large;

  .component {
    .body {
      position: relative;
      background-color: $color-white;
      transition:
        border-bottom 200ms $button-easing,
        color 200ms $button-easing;
      border-radius: $border-radius-large;
      padding: $baseline-3;
    }
  }
}

:host(.top-right),
:host(.top-left) {
  .component {
    .arrow {
      display: block;
      bottom: -($arrow-width * 0.5);
      box-shadow: 1px 1px 2px 0 rgba($color-black, 0.15);
    }
  }
}

:host(.bottom-right),
:host(.bottom-left) {
  .component {
    .arrow {
      display: block;
      top: -($arrow-width * 0.5);
      box-shadow: -1px -1px 2px 0 rgba($color-black, 0.15);
    }
  }
}

.component.sdx--dark-theme {
  .body,
  .arrow {
    background-color: $color-dusk-tint-2-dark-theme;
  }
}
